export enum CatalogueItemUserBidStatusEnum {
    Active = 1,
    ReOffered = 2
}
